import { useState } from "react";
import UserListTable from "../../components/admin/UserListTable.jsx";
import Button from "../../components/ui/Button.jsx";
import InviteUserModal from "../../components/admin/InviteUserModal.jsx";

export default function Users() {
  const [inviteOpen, setInviteOpen] = useState(false);
  const [refreshNonce, setRefreshNonce] = useState(0);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
        <h2 style={{ fontSize: "18px", fontWeight: 600, margin: "0 0 4px 0" }}>Users</h2>
        <Button size="sm" onClick={() => setInviteOpen(true)}>
          + Invite user
        </Button>
      </div>
      <p className="text-secondary" style={{ fontSize: "14px", margin: "0 0 16px 0" }}>
        Manage team members, roles, and account status.
      </p>
      <UserListTable refreshNonce={refreshNonce} />
      {inviteOpen ? (
        <InviteUserModal
          onClose={() => setInviteOpen(false)}
          onInvited={() => setRefreshNonce((v) => v + 1)}
        />
      ) : null}
    </div>
  );
}
